import React from 'react';
import { useDispatch } from 'react-redux';
import { loginUser } from '../actions/auth';
import { Shield } from 'lucide-react';

const Login = () => {
  const dispatch = useDispatch();

  const handleLogin = () => {
    dispatch(loginUser());
  };

  return (
    <div className="w-screen h-screen bg-gray-50 flex flex-col">
      <div className="flex-1 flex items-center justify-center">
        <div className="w-full max-w-md px-6">
          <div className="text-center mb-10">
            <h1 className="text-4xl font-bold text-gray-900 mb-2">
              Welcome to Cloudify
            </h1>
            <p className="text-gray-600 text-lg">
              Your infrastructure management solution
            </p>
          </div>
          <div className="bg-white p-8 rounded-lg shadow-md space-y-6">
            <h2 className="text-2xl font-semibold text-gray-900 text-center">
              Sign in to your account
            </h2>
            <button
              onClick={handleLogin}
              className="w-full flex items-center justify-center px-4 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-200"
            >
              <Shield className="w-5 h-5 mr-2" />
              Sign in with JumpCloud
            </button>
            <p className="text-sm text-gray-500 text-center">
              Secure authentication powered by JumpCloud SSO
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
